export const en: Record<string, string> = {
  "detail.service.about": "About this service",
  "detail.service.included": "What's included",
  "detail.service.reviews": "Reviews & Ratings",
  "detail.service.noReviews": "No reviews yet.",
  "detail.service.noFeedback": "No written feedback is available yet.",
  "detail.service.area": "Service Area",
  "detail.service.startingAt": "Starting at",
  "detail.service.price": "Price",
  "detail.service.finalPrice": "Final price depends on project scope, materials, and location.",
  "detail.service.requestQuote": "Request a Quote",
  "detail.service.messageProvider": "Message Provider",
  "detail.service.aboutProvider": "About the Provider",
  "detail.service.servicesListed": "Services",
  "detail.service.escrowHire": "Escrow & milestone protection on hire",
  "detail.service.verifiedProvider": "Verified provider",
  "detail.service.identityBusiness": "Identity and business verified",
  "detail.service.securePayments": "Secure payments",
  "detail.service.escrowProtection": "Escrow and milestone protection",
  "detail.service.transparentReviews": "Transparent reviews",
  "detail.service.pastFeedback": "Feedback from past clients",
  "detail.service.from": "From",
  "detail.service.quote": "Quote",
  "detail.service.noSimilar": "No similar services available yet.",
  "detail.job.description": "Job Description",
  "detail.job.skillsResponsibilities": "Skills & Responsibilities",
  "detail.job.noRequirements": "Detailed requirements have not been listed. Ask the employer about the work before applying.",
  "detail.job.benefits": "Benefits & Perks",
  "detail.job.noBenefits": "Benefits have not been listed for this job. Ask the employer for details.",
  "detail.job.aboutEmployer": "About the Employer",
  "detail.job.viewProfile": "View profile",
  "detail.job.offeredSalary": "Offered salary",
  "detail.job.applicants": "applicants",
  "detail.job.posted": "Posted",
  "detail.job.memberSince": "Member since",
  "detail.job.similarJobs": "Similar Jobs",
  "detail.job.noSimilar": "No similar jobs are available right now.",
  "detail.company.businessArea": "Business Area",
  "detail.company.about": "About",
  "detail.company.information": "Company Information",
  "detail.company.industry": "Industry",
  "detail.company.businessStatus": "Business status",
  "detail.company.productsServices": "Products & Services",
  "detail.company.areasExpertise": "Areas of Expertise",
  "detail.company.similarCompanies": "Similar Companies",
  "detail.project.bidSummary": "Bid Summary",
  "detail.project.bidsReceived": "Bids Received",
  "detail.project.openUntil": "Open until",
  "detail.project.closedOn": "Closed on",
  "detail.project.estimatedBudget": "Estimated Budget",
  "detail.project.targetCompletion": "Target completion date",
  "detail.project.aboutClient": "About the Client",
  "detail.project.projectsPosted": "Projects Posted",
  "detail.project.projectsAwarded": "Projects Awarded",
  "detail.project.identityVerified": "Identity Verified",
  "detail.project.sealedProcess": "Sealed-Bid Process",
  "detail.rfq.summary": "RFQ Summary",
  "detail.rfq.aboutRequester": "About the Requester",
  "detail.rfq.requester": "RFQ requester",
  "detail.rfq.rfqsPosted": "RFQs posted",
  "detail.rfq.rfqsAwarded": "RFQs awarded",
  "detail.profile.employer": "Employer",
  "detail.profile.company": "Company",
  "detail.profile.individual": "Individual",
  "detail.profile.jobsPosted": "Jobs posted",
  "detail.profile.peopleHired": "People hired",
  "detail.profile.reviewsUnavailable": "Reviews unavailable",
  "detail.rfq.status": "Status",
  "detail.rfq.lineItems": "Line items",
  "detail.rfq.quotesReceived": "Quotes received",
  "detail.rfq.closes": "Closes",
  "detail.rfq.requestedItems": "Requested Items",
  "detail.rfq.suggestedOrganizations": "Suggested organizations",
  "detail.rfq.submitQuote": "Submit Your Quote",
  "detail.item.marketplace": "Marketplace",
  "detail.item.description": "Description",
  "detail.item.itemDetails": "Item details",
  "detail.item.features": "Features",
  "detail.item.forRent": "For Rent",
  "detail.item.forSale": "For Sale",
  "detail.item.condition": "Condition",
  "detail.item.brand": "Brand",
  "detail.item.model": "Model",
  "detail.item.storage": "Storage",
  "detail.item.color": "Color",
  "detail.item.category": "Category",
  "detail.item.noFeatures": "No features listed. Ask the seller for details.",
  "detail.item.notProvided": "Not provided",
  "detail.item.aboutRental": "About this rental",
  "detail.item.kind.material": "Material / Supply",
  "detail.item.kind.equipment": "Equipment / Tool",
  "detail.item.kind.property": "Property",
  "detail.item.kind.vehicle_transport": "Vehicle / Transport",
  "detail.item.kind.heavy_machinery": "Heavy Machinery",
  "detail.item.kind.electrical": "Electrical",
  "detail.item.kind.plumbing_sanitary": "Plumbing / Sanitary",
  "detail.item.kind.business": "Business for Sale",
  "detail.item.kind.safety_ppe": "Safety / PPE",
  "detail.item.kind.formwork_scaffold": "Formwork / Scaffolding",
  "detail.item.kind.fixtures_finishes": "Fixtures / Finishes",
  "detail.item.kind.site_facilities": "Office / Site Facilities",
  "detail.item.kind.surplus_salvaged": "Surplus / Salvaged Materials",
  "detail.item.categoryValue.Gadget": "Gadget",
  "detail.item.used": "Used",
  "detail.item.new": "New",
  "detail.item.posted": "Posted",
  "detail.item.viewsUnavailable": "Views unavailable",
  "detail.item.favoritesUnavailable": "Favorites unavailable",
  "detail.item.inclusions": "Inclusions:",
  "detail.item.included": "Included:",
  "detail.item.reasonForSelling": "Reason for selling:",
  "detail.item.sellerReviews": "Seller reviews",
  "detail.item.loadingReviews": "Loading reviews…",
  "detail.item.noSellerReviews": "This seller has no reviews yet.",
  "detail.item.listingSummary": "Listing Summary",
  "detail.item.aboutSeller": "About the Seller",
  "detail.item.aboutOwner": "About the Owner",
  "detail.item.manageListing": "Manage listing",
  "detail.item.ownListingSummary": "This is your listing.",
  "detail.item.sellerInformation": "Seller information",
  "detail.item.ownerInformation": "Owner information",
  "detail.item.viewProfile": "View profile →",
  "detail.item.member": "Member",
  "detail.item.noReviews": "No reviews yet",
  "detail.item.reviews": "reviews",
  "detail.item.locationUnavailable": "Location not provided",
  "detail.item.memberSince": "Member since",
  "detail.item.memberSinceUnavailable": "Member since unavailable",
  "detail.item.listings": "Listings",
  "detail.item.sold": "Sold",
  "detail.item.rentals": "Rentals",
  "detail.item.responseRate": "Response rate",
  "detail.item.followSeller": "Follow Seller",
  "detail.item.followUnavailable": "Following sellers is not available yet",
  "detail.item.price": "Price",
  "detail.item.rentalPrice": "Rental price",
  "detail.item.outOfStock": "Out of stock",
  "detail.item.listingUnavailable": "Listing unavailable",
  "detail.item.availableForRent": "Available for rent",
  "detail.item.available": "available",
  "detail.item.messageSeller": "Message seller",
  "detail.item.messageOwner": "Message owner",
  "detail.item.escrowNote": "Payment is held in escrow until receipt is confirmed.",
  "detail.item.meetupDelivery": "Meetup / Delivery",
  "detail.item.pickupReturn": "Pickup / Return",
  "detail.item.itemLocation": "Item location",
  "detail.item.location": "Location",
  "detail.item.handoverOptions": "Handover options",
  "detail.item.arrangeWithSeller": "Arrange with the seller",
  "detail.item.handover.pickup": "Pickup",
  "detail.item.handover.meetup": "Meetup",
  "detail.item.handover.delivery_arrangement": "Delivery by arrangement",
  "detail.item.operatingStatus": "Operating status",
  "detail.item.operatingStatus.operating": "Operating",
  "detail.item.operatingStatus.temporarily_closed": "Temporarily closed",
  "detail.item.operatingStatus.closed": "Closed",
  "detail.item.operatingStatus.not_yet_operating": "Not yet operating",
  "detail.item.deliveryOptions": "Delivery options",
  "detail.item.pickupOptions": "Pickup options",
  "detail.item.meetupOptions": "Meetup options",
  "detail.item.returnOptions": "Return options",
  "detail.item.paymentMethods": "Payment methods",
  "detail.item.walletBalance": "Wallet balance",
  "detail.item.paymentMethodsNote": "Add funds to your wallet using the available channels before checkout. Direct card, GCash, Maya, and bank transfer selection is not part of this item checkout.",
  "detail.item.day": "day",
  "detail.item.days": "days",
  "detail.item.asking": "asking",
  "detail.item.orderPlaced": "Order placed!",
  "detail.item.escrowPlaced": "is held in escrow until you confirm receipt.",
  "detail.item.myOrders": "My Orders",
  "detail.item.keepBrowsing": "Keep browsing",
  "detail.item.ownListing": "This is your listing. Manage it from your",
  "detail.item.dashboard": "dashboard",
  "detail.item.noLongerAvailable": "This listing is no longer available.",
  "detail.item.askBusiness": "Business sale quotation",
  "detail.item.inquiryHint": "Request details and discuss the sale with the seller.",
  "detail.item.inquireBusiness": "Inquire about this business",
  "detail.item.orderDetails": "Order details",
  "detail.item.pickupDate": "Pickup date",
  "detail.item.returnDate": "Return date",
  "detail.item.rentalDateHint": "Dates calculate the rental duration. Confirm handoff with the owner. Refundable deposit: not provided.",
  "detail.item.invalidDates": "Choose pickup and return dates 1 to 3,650 days apart.",
  "detail.item.quantity": "Quantity",
  "detail.item.decreaseQuantity": "Decrease quantity",
  "detail.item.increaseQuantity": "Increase quantity",
  "detail.item.total": "Total",
  "detail.item.rentNow": "Rent now",
  "detail.item.signInFirst": "You'll be asked to sign in first.",
  "detail.item.activeListings": "Active listings",
  "detail.item.items": "items",
  "detail.item.basedOnSellerReviews": "Based on {count} seller reviews",
  "detail.item.askingPrice": "Asking price",
  "detail.item.inquire": "Request quotation",
  "detail.item.noDescriptionSeller": "The seller has not added a description yet.",
  "detail.item.noDescriptionOwner": "The owner has not added a description yet.",
  "detail.item.loading": "Loading item…",
  "detail.item.notFound": "Item not found",
  "detail.item.browse": "Browse Materials",
  "detail.item.pickupAgreement": "Agree on pickup, return, and a condition check with the owner before booking.",
  "detail.item.rentalTerms": "Rental terms",
  "detail.item.rate": "Rate",
  "detail.item.refundableDeposit": "Refundable deposit",
  "detail.item.minimumRental": "Minimum rental",
  "detail.item.returnCondition": "Return condition",
  "detail.item.confirmWithOwner": "Confirm with owner",
  "detail.item.contactBusiness": "Contact the seller to discuss this business.",
  "detail.item.payment": "Payment",
  "detail.item.walletPaid": "Paid from your wallet balance",
  "detail.item.checkoutFeedback": "How was checking out?",
  "detail.item.availableOnly": "Only {count} available.",
  "detail.item.orderFailed": "Could not place the order.",
  "detail.item.rentalDateHintFull": "Dates calculate the rental duration. Confirm the exact handoff schedule with the owner. Refundable deposit: not provided.",
  "detail.company.companies": "Companies",
  "detail.company.servicesProducts": "Services & products",
  "detail.company.overview": "Overview",
  "detail.company.services": "Services",
  "detail.company.products": "Products",
  "detail.company.reviews": "Reviews",
  "detail.company.ratingsBasis": "Ratings are based on reviews posted for this company.",
  "detail.company.serves": "Serves",
  "detail.company.editBusiness": "Edit business profile",
  "detail.company.contact": "Contact",
  "detail.company.requestQuote": "Request Quote",
  "detail.company.viewProfile": "View profile",
  "detail.company.startingAt": "Starting at",
  "detail.company.inquire": "Inquire",
  "detail.company.productsEquipment": "Products & Equipment",
  "detail.company.newRating": "New",
  "detail.company.title": "Company",
  "detail.company.reviewsRatings": "Reviews & Ratings",
  "detail.company.similar": "Similar Companies",
  "detail.rfq.awarded": "Awarded",
  "detail.rfq.open": "Open",
  "detail.rfq.openQuotes": "Open for Quotes",
  "detail.rfq.category": "Category",
  "detail.rfq.due": "Due",
  "detail.rfq.postedBy": "Posted by",
  "detail.rfq.messageBuyer": "Message buyer",
  "detail.rfq.item": "Item",
  "detail.rfq.quantity": "Qty",
  "detail.rfq.unit": "Unit",
  "detail.rfq.terms": "Terms",
  "detail.rfq.companySupplier": "Company / Supplier",
  "detail.rfq.yourCompany": "Your company name",
  "detail.rfq.validity": "Validity",
  "detail.rfq.notes": "Notes",
  "detail.rfq.quoteTotal": "Quote total",
  "detail.rfq.submitQuoteShort": "Submit a Quote",
  "detail.rfq.unitPrice": "unit price",
  "detail.rfq.validityHint": "Select or type, e.g. 30 days",
  "detail.rfq.notesHint": "Inclusions, delivery, warranty…",
  "detail.item.buyNow": "Buy now",
};

export const tl: Record<string, string> = {
};
